export default "__VITE_ASSET__BZ3A9Bae__"